const toAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

const roundMoney = (value) => Math.round((toAmount(value) + Number.EPSILON) * 100) / 100;

const getItemSupplierAmounts = (item = {}) => {
  const quantity = Math.max(1, toAmount(item.quantity) || 1);
  const unitCost = toAmount(item.selectedProviderVariant?.costPrice);
  const productCost = roundMoney(unitCost * quantity);
  // shippingQuote.price is the amount CJ actually charged the seller on the
  // CJ platform for this shipment -- the supplier postage included in the
  // order total. shippingQuote.totalPostageFee (CJ's own quote total) is
  // kept on the quote for reference/audit but is no longer used here.
  const postage = roundMoney(item.shippingQuote?.price);
  const calculatedTotal = roundMoney(productCost + postage);
  const savedTotal = toAmount(item.totalSupplierCost);

  return {
    quantity,
    unitCost,
    productCost,
    postage,
    calculatedTotal,
    payable: savedTotal > 0 ? roundMoney(savedTotal) : calculatedTotal,
  };
};

const getOrderSupplierTotals = (items = []) => items.reduce((totals, item) => {
  const amounts = getItemSupplierAmounts(item);
  totals.productCost = roundMoney(totals.productCost + amounts.productCost);
  totals.postage = roundMoney(totals.postage + amounts.postage);
  totals.calculatedTotal = roundMoney(totals.calculatedTotal + amounts.calculatedTotal);
  totals.payable = roundMoney(totals.payable + amounts.payable);
  return totals;
}, { productCost: 0, postage: 0, calculatedTotal: 0, payable: 0 });

module.exports = { getItemSupplierAmounts, getOrderSupplierTotals };
